import { MagnifyingGlass } from "@phosphor-icons/react";
import type * as React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

type SearchInputSize = "sm" | "md";

type SearchInputProps = Omit<React.ComponentProps<"input">, "onChange"> & {
	onValueChange: (value: string) => void;
	sizeVariant?: SearchInputSize;
	wrapperClassName?: string;
};

const SIZE_CLASSES: Record<SearchInputSize, { input: string; icon: string }> = {
	sm: { input: "h-8 pl-8 text-sm", icon: "left-2.5" },
	md: { input: "h-10 pl-9", icon: "left-3" },
};

function SearchInput({
	value,
	onValueChange,
	sizeVariant = "sm",
	className,
	wrapperClassName,
	placeholder,
	"aria-label": ariaLabel,
	name = "search",
	autoComplete = "off",
	...props
}: SearchInputProps) {
	const sizes = SIZE_CLASSES[sizeVariant];
	return (
		<div className={cn("relative", wrapperClassName)}>
			<MagnifyingGlass
				aria-hidden="true"
				className={cn(
					"absolute top-1/2 size-4 -translate-y-1/2 text-muted-foreground",
					sizes.icon,
				)}
			/>
			<Input
				{...props}
				name={name}
				autoComplete={autoComplete}
				aria-label={ariaLabel ?? placeholder}
				placeholder={placeholder}
				value={value ?? ""}
				onChange={(e) => onValueChange(e.target.value)}
				className={cn(sizes.input, className)}
			/>
		</div>
	);
}

export { SearchInput };
